import { SettingsModal } from "@/components/ui";
import { useNavigate } from "@tanstack/react-router";

export const Settings = () => {
  const navigate = useNavigate();

  return (
    <SettingsModal
      open={true}
      onOpenChange={() => {
        void navigate({ to: "/app", replace: true });
      }}
    />
  );
};
